import { useMemo, useState } from 'react'

import { useRouter } from 'next/router'
import { ParsedUrlQuery } from 'querystring'

import { useSelector } from 'react-redux'
import { institutionItemSelectors } from '@ucheba/store/institutions/item'
import { UzSectionsEnum } from '../../../../components/LayoutInstitution/types'
import {
  sectionsEventsNavigationItems,
  IUzSectionsNavigationItem,
} from '../../../../components/LayoutInstitution/constants'

type TUseInstitutionSideMenu = (currentItemName: string) => {
  logo: string
  currentMenuItem: string | undefined
  sectionsItems: IUzSectionsNavigationItem[]
  showAll: boolean
  query: ParsedUrlQuery
  setShowAll: React.Dispatch<React.SetStateAction<boolean>>
}

export const useInstitutionSideMenu: TUseInstitutionSideMenu = (currentItemName) => {
  const [showAll, setShowAll] = useState(false)

  const { query } = useRouter()

  const currentMenuItem = useMemo(
    () => sectionsEventsNavigationItems.find((item) => item.key === currentItemName),
    [currentItemName]
  )?.name

  const {
    partnerCompanies,
    hasNews,
    hasOlympiads,
    hasPrograms,
    hasSubdivisions,
    members,
    hasArticles,
    paidPackage,
  } = useSelector(institutionItemSelectors.currentInstitution)

  const sectionsItems = useMemo(() => {
    let list = sectionsEventsNavigationItems

    // Далее идет фильтрация от тех пунктов меню
    // по которым ничего нет в данном УЗ

    if (!hasNews) {
      list = list.filter(({ key }) => key !== UzSectionsEnum.news)
    }

    if (!hasOlympiads) {
      list = list.filter(({ key }) => key !== UzSectionsEnum.olympiads)
    }

    if (!hasPrograms) {
      list = list.filter(({ key }) => key !== UzSectionsEnum.programs)
    }

    if (!hasSubdivisions) {
      list = list.filter(({ key }) => key !== UzSectionsEnum.units)
    }

    if (!members.length) {
      list = list.filter(({ key }) => key !== UzSectionsEnum.teachers)
    }

    if (!partnerCompanies.length) {
      list = list.filter(({ key }) => key !== UzSectionsEnum.partners)
    }

    if (!hasArticles) {
      list = list.filter(({ key }) => key !== UzSectionsEnum.articles)
    }

    if (!hasArticles) {
      list = list.filter(({ key }) => key !== currentItemName)
    }

    // Далее фильтрация для тех УЗ
    // у которых нет платного пакета

    if (!paidPackage) {
      list = list.filter(({ key }) => key !== UzSectionsEnum.events)
      list = list.filter(({ key }) => key !== UzSectionsEnum.comments)
    }

    return list
  }, [
    currentItemName,
    hasArticles,
    hasNews,
    hasOlympiads,
    hasPrograms,
    hasSubdivisions,
    members.length,
    partnerCompanies.length,
    paidPackage,
  ])

  return {
    currentMenuItem,
    sectionsItems,
    showAll,
    query,
    setShowAll,
  }
}
